<template>
  <div class="code-rule">
    <!-- 编号规则管理 -->
    <el-form class="zwx-form" key="msForm" ref="msForm" :model="msForm" :inline="true" label-position="right"
             @submit.native.prevent>
      <div class="self-adapting-condition">
        <el-form-item label="名称：">
          <el-input class="zwx-input" v-model.trim="msForm.ruleNameLike" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="编码：">
          <el-input class="zwx-input" v-model.trim="msForm.ruleCodeLike" placeholder="请输入" clearable />
        </el-form-item>
        <div class="condition-button-row">
          <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">
            查询
          </el-button>
          <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add">添加</el-button>
        </div>
      </div>
    </el-form>

    <!-- 列表展示部分 -->
    <el-table class="zwx-table" ref="zwxTableRef" height=" calc(100vh - 152px)" row-key="rid" :data="tableList" border
              stripe>
      <el-table-column prop="ruleName" label="名称" width="300" header-align="center" align="left"
                       :show-overflow-tooltip="true"/>
      <el-table-column prop="ruleCode" label="编码" width="200" header-align="center" align="center"
                       :show-overflow-tooltip="true"/>
      <el-table-column prop="ruleDescribe" label="描述" width="500" header-align="center" align="left"
                       :show-overflow-tooltip="true"/>
      <el-table-column label="操作" header-align="left" align="left" min-width="80" fixed="right">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" icon="el-icon-top-right" @click="edit(scope.row.rid)">编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger" @click="deleterow(scope.row.rid)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange" />
    <!-- 添加弹框 -->
    <base-dialog ref="editDialogRef" @determine="determine()" @close="close()" @cancel="cancel()" title="编号规则"
                 :pagination="false">
      <el-form class="zwx-form edit-form" key="editForm" ref="editFormRef" :model="editForm" :inline="true" label-position="right"
               @submit.native.prevent :rules="editFormRules">
        <div class="edit-row">
          <el-form-item label="名称：" prop="ruleName" label-width="60px">
            <el-input class="zwx-input" style="width:240px !important" v-model.trim="editForm.ruleName"
                      placeholder="请输入" clearable maxlength="50" />
          </el-form-item>
          <el-form-item label="编码：" prop="ruleCode" label-width="155px">
            <el-input class="zwx-input" style="width:240px !important" v-model.trim="editForm.ruleCode"
                      placeholder="请输入" clearable maxlength="20" />
          </el-form-item>
        </div>
        <div class="edit-row">
          <el-form-item label="描述：" prop="ruleDescribe" label-width="60px">
            <el-input class="zwx-textarea" type="textarea" :rows="3" style="width:655px!important;"
                      v-model.trim="editForm.ruleDescribe" placeholder="请输入" maxlength="200" clearable />
          </el-form-item>
        </div>
        <div class="rule-info edit-row">
          <div>
            <div class="rule-remark" style="padding-left: 60px;">前缀</div>
            <el-form-item label="规则：" prop="fixedPrefix" label-width="60px">
              <el-input class="zwx-input" style="width:80px !important" v-model.trim="editForm.fixedPrefix"
                        placeholder="请输入" clearable maxlength="50" />
            </el-form-item>
          </div>
          <div>
            <div class="rule-remark">分隔符</div>
            <el-form-item prop="prefixSeparator">
              <el-input class="zwx-input" style="width:80px !important" v-model.trim="editForm.prefixSeparator"
                        placeholder="请输入" clearable maxlength="20" />
            </el-form-item>
          </div>
          <div>
            <div class="rule-remark">额外编号</div>
            <el-form-item prop="extraCodeType">
              <el-select style="width:150px !important" class="zwx-select select-component"
                         popper-class="zwx-select-popper" filterable v-model="editForm.extraCodeType"
                         placeholder="请选择" clearable>
                <el-option v-for="item in CodeEnum.EXTRA_CODE_TYPE_LIST" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <div class="rule-remark">分隔符</div>
            <el-form-item prop="extraCodeSeparator">
              <el-input class="zwx-input" style="width:80px !important" v-model.trim="editForm.extraCodeSeparator"
                        placeholder="请输入" clearable maxlength="20" />
            </el-form-item>
          </div>
          <div>
            <div class="rule-remark">流水位数</div>
            <el-form-item prop="codeLength">
              <el-input-number class="zwx-input-number" :step="1" :step-strictly="true" controls-position="right"
                               style="width:80px !important" v-model="editForm.codeLength" :min="0" :max="9"
                               label="数量"></el-input-number>
            </el-form-item>
          </div>
          <div>
            <div class="rule-remark">分隔符</div>
            <el-form-item prop="suffixSeparator">
              <el-input class="zwx-input" style="width:80px !important" v-model.trim="editForm.suffixSeparator"
                        placeholder="请输入" clearable maxlength="20" />
            </el-form-item>
          </div>
          <div>
            <div class="rule-remark">后缀</div>
            <el-form-item prop="fixedSuffix">
              <el-input class="zwx-input" style="width:80px !important" v-model.trim="editForm.fixedSuffix"
                        placeholder="请输入" clearable maxlength="20" />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
import tool from "./api.js";

export default {
  name: "CodeRule",
  data() {
    return {
      api: this.$store.state.api,
      baseUrl: this.$store.state.baseUrl,
      CodeEnum : {
        // 额外编号类型
        EXTRA_CODE_TYPE_LIST: [
          { label: "无", value: 0 },
          { label: "年份(YY)", value: 5 },
          { label: "年份(YYYY)", value: 1 },
          { label: "日期(YYYYMMDD)", value: 2 },
          { label: "行政区划代码(4位)", value: 3 },
          { label: "行政区划代码(6位)", value: 4 }
        ]
      },
      msForm: {
        ruleNameLike: "",
        ruleCodeLike: ""
      },
      editForm: {
        rid: "",
        ruleName: "",
        ruleCode: "",
        ruleDescribe: "",
        fixedPrefix: "",
        prefixSeparator: "",
        extraCodeType: 0,
        extraCodeSeparator: "",
        codeLength: "",
        suffixSeparator: "",
        fixedSuffix: ""
      },
      originalEditForm: "",
      editFormRules: {
        ruleName: [{ required: true, message: "请输入名称", trigger: ["blur", "change"] }],
        ruleCode: [{ required: true, message: "请输入编码", trigger: ["blur", "change"] }],
        extraCodeType: [{ required: true, message: "请选择额外编号类型", trigger: ["blur", "change"] }],
        codeLength: [{ required: true, message: "请输入流水位数", trigger: ["blur", "change"] }]
      },
      pageSize: 18,
      total: 0,
      currentPage: 1,
      tableList: []
    };
  },
  async mounted() {
    this.originalEditForm = JSON.stringify(this.editForm);
    this.search(this.currentPage);
  },
  activated() {
  },

  methods: {
    // 获取列表数据
    async search(currentPage) {
      this.currentPage = currentPage;
      const { data } = await tool.codeRuleList({ currentPage, ...this.msForm, pageSize: this.pageSize }, this);
      this.tableList = data.dataList || [];
      this.total = data.total || 0;
    },

    add() {
      this.$refs.editDialogRef.show(true);
    },
    // 编辑
    async edit(rid) {
      let { data } = await tool.codeRuleDetail({ rid: rid }, this);
      this.$refs.editDialogRef.show(true);
      this.editForm = { ...this.editForm, ...data.data };
    },
    // 删除
    async deleterow(rid) {
      this.$system.msgbox("", "提示", "是否确定删除？", "确定", "取消", async () => {
        let data = await tool.codeRuleDelete({ rid: rid }, this);
        this.$system.notify("成功", data.mess, "success");
        this.search(this.currentPage);
      });
    },
    currentChange(currentPage) {
      this.search(currentPage);
    },
    error() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    },
    determine() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return;
        let data = await tool.codeRuleSave({ ...this.editForm }, this);
        this.$system.notify("成功", data.mess, "success");
        this.cancel();
        this.search(this.currentPage);
      });
    },
    close() {
    },
    cancel() {
      this.editForm = JSON.parse(this.originalEditForm);
      this.$refs.editFormRef.clearValidate();
      this.$refs.editDialogRef.show(false);
    }
  }
};
</script>

<style lang="less" scoped>
.code-rule {
  :deep(.el-dialog) {
    min-width: 770px !important;
    width: 770px !important;
  }

  /deep/ .el-select.zwx-select.select-component input.el-input__inner {
    width: 150px !important;
  }

  /deep/ .zwx-input-number .el-input-number__increase {
    line-height: 15px !important;
    border-left: 1px solid #dcdfe6;
  }

  /deep/ .zwx-input-number .el-input-number__decrease {
    line-height: 15px !important;
  }

  .rule-info {
    display: flex;

    .el-form-item {
      margin-right: 5px !important;
    }

    .rule-remark {
      text-align: center;
      padding-bottom: 2px;
      padding-right: 5px;
    }
  }
}
</style>
